import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronDownIcon } from 'lucide-react';
export function ThresholdsPage() {
  const [selectedDivision, setSelectedDivision] = useState('Junior Level');
  const divisions = ['Junior Level', 'Senior Level', 'Cadet Level', 'Kids Level', 'W.T.F. Olympic Category', 'W.T.F. Para Taekwondo'];
  const maleData = [{
    category: '- 45 Kg / 99 lbs',
    size: '#1',
    level: '22'
  }, {
    category: '- 48 Kg / 106 lbs',
    size: '#2',
    level: '23'
  }, {
    category: '- 51 Kg / 112 lbs',
    size: '#2',
    level: '24'
  }, {
    category: '- 55 Kg / 121 lbs',
    size: '#2',
    level: '25'
  }, {
    category: '- 59 Kg / 130 lbs',
    size: '#3',
    level: '27'
  }, {
    category: '- 63 Kg / 139 lbs',
    size: '#3',
    level: '28'
  }, {
    category: '- 68 Kg / 150 lbs',
    size: '#3',
    level: '30'
  }, {
    category: '- 73 Kg / 161 lbs',
    size: '#3',
    level: '32'
  }, {
    category: '- 78 Kg / 172 lbs',
    size: '#4',
    level: '33'
  }, {
    category: '+ 78 Kg / 172 lbs',
    size: '#4',
    level: '34'
  }];
  const femaleData = [{
    category: '- 42 Kg / 93 lbs',
    size: '#1',
    level: '20'
  }, {
    category: '- 44 Kg / 97 lbs',
    size: '#1',
    level: '21'
  }, {
    category: '- 46 Kg / 101 lbs',
    size: '#1',
    level: '22'
  }, {
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '22'
  }, {
    category: '- 52 Kg / 115 lbs',
    size: '#2',
    level: '23'
  }, {
    category: '- 55 Kg / 121 lbs',
    size: '#2',
    level: '24'
  }, {
    category: '- 59 Kg / 130 lbs',
    size: '#3',
    level: '25'
  }, {
    category: '- 63 Kg / 139 lbs',
    size: '#3',
    level: '26'
  }, {
    category: '- 68 Kg / 150 lbs',
    size: '#3',
    level: '28'
  }, {
    category: '+ 68 Kg / 150 lbs',
    size: '#4',
    level: '30'
  }];
  const seniorMaleData = [{
    weight: 'FIN',
    category: '- 54 Kg / 119 lbs',
    size: '#2',
    level: '26'
  }, {
    weight: 'FLY',
    category: '- 58 Kg / 128 lbs',
    size: '#3',
    level: '30'
  }, {
    weight: 'BANTAM',
    category: '- 63 Kg / 139 lbs',
    size: '#3',
    level: '31'
  }, {
    weight: 'FEATHER',
    category: '- 68 Kg / 159 lbs',
    size: '#3',
    level: '32'
  }, {
    weight: 'LIGHT',
    category: '- 74 Kg / 163 lbs',
    size: '#3',
    level: '33'
  }, {
    weight: 'WELTER',
    category: '- 80 Kg / 176 lbs',
    size: '#4',
    level: '34'
  }, {
    weight: 'MIDDLE',
    category: '- 87 Kg / 192 lbs',
    size: '#4',
    level: '36'
  }, {
    weight: 'HEAVY',
    category: '+ 87 Kg / 192 lbs',
    size: '#4/5',
    level: '38'
  }];
  const seniorFemaleData = [{
    weight: 'FIN',
    category: '- 46 Kg / 101 lbs',
    size: '#1',
    level: '22'
  }, {
    weight: 'FLY',
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '25'
  }, {
    weight: 'BANTAM',
    category: '- 53 Kg / 117 lbs',
    size: '#2',
    level: '26'
  }, {
    weight: 'FEATHER',
    category: '- 57 Kg / 126 lbs',
    size: '#3',
    level: '27'
  }, {
    weight: 'LIGHT',
    category: '- 62 Kg / 137 lbs',
    size: '#3',
    level: '28'
  }, {
    weight: 'WELTER',
    category: '- 67 Kg / 148 lbs',
    size: '#3',
    level: '30'
  }, {
    weight: 'MIDDLE',
    category: '- 73 Kg / 161 lbs',
    size: '#3',
    level: '31'
  }, {
    weight: 'HEAVY',
    category: '+ 73 Kg / 161 lbs',
    size: '#4',
    level: '32'
  }];
  const cadetMaleData = [{
    category: '- 33 Kg / 73 lbs',
    size: '#0',
    level: '17'
  }, {
    category: '- 37 Kg / 82 lbs',
    size: '#0',
    level: '18'
  }, {
    category: '- 41 Kg / 90 lbs',
    size: '#1',
    level: '19'
  }, {
    category: '- 45 Kg / 99 lbs',
    size: '#1',
    level: '21'
  }, {
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '22'
  }, {
    category: '- 53 Kg / 117 lbs',
    size: '#2',
    level: '24'
  }, {
    category: '- 57 Kg / 126 lbs',
    size: '#2',
    level: '25'
  }, {
    category: '- 61 Kg / 134 lbs',
    size: '#3',
    level: '27'
  }, {
    category: '- 65 Kg / 143 lbs',
    size: '#3',
    level: '28'
  }, {
    category: '+ 65 Kg / 143 lbs',
    size: '#3',
    level: '30'
  }];
  const cadetFemaleData = [{
    category: '- 29 Kg / 64 lbs',
    size: '#0',
    level: '16'
  }, {
    category: '- 33 Kg / 73 lbs',
    size: '#0',
    level: '17'
  }, {
    category: '- 37 Kg / 82 lbs',
    size: '#0',
    level: '18'
  }, {
    category: '- 41 Kg / 90 lbs',
    size: '#1',
    level: '19'
  }, {
    category: '- 44 Kg / 97 lbs',
    size: '#1',
    level: '20'
  }, {
    category: '- 47 Kg / 104 lbs',
    size: '#2',
    level: '21'
  }, {
    category: '- 51 Kg / 112 lbs',
    size: '#2',
    level: '22'
  }, {
    category: '- 55 Kg / 121 lbs',
    size: '#2',
    level: '23'
  }, {
    category: '- 59 Kg / 130 lbs',
    size: '#3',
    level: '24'
  }, {
    category: '+ 59 Kg / 130 lbs',
    size: '#3',
    level: '25'
  }];
  const kids6to7Data = [{
    category: '- 19 Kg',
    size: '#00',
    level: '6'
  }, {
    category: '- 23 Kg',
    size: '#00',
    level: '6'
  }, {
    category: '- 27 Kg',
    size: '#00',
    level: '6'
  }, {
    category: '+ 27 Kg',
    size: '#00',
    level: '6'
  }];
  const kids8to9Data = [{
    category: '- 21 Kg',
    size: '#00',
    level: '8'
  }, {
    category: '- 25 Kg',
    size: '#00',
    level: '10'
  }, {
    category: '- 30 Kg',
    size: '#00',
    level: '12'
  }, {
    category: '+ 30 Kg',
    size: '#0',
    level: '14'
  }];
  const kids10to11Data = [{
    category: '- 30 Kg',
    size: '#00',
    level: '12'
  }, {
    category: '- 35 Kg',
    size: '#0',
    level: '14'
  }, {
    category: '- 40 Kg',
    size: '#0',
    level: '16'
  }, {
    category: '+ 40 Kg',
    size: '#1',
    level: '12'
  }];
  const olympicMaleData = [{
    category: '- 58 Kg / 128 lbs',
    size: '#3',
    level: '30'
  }, {
    category: '+ 58/-68 Kg / 128/150 lbs',
    size: '#3',
    level: '32'
  }, {
    category: '+68/-80 Kg / 150/176 lbs',
    size: '#4',
    level: '34'
  }, {
    category: '+ 80 Kg / 176 lbs',
    size: '#5',
    level: '36'
  }];
  const olympicFemaleData = [{
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '25'
  }, {
    category: '+ 49/-57 Kg / 108/126 lbs',
    size: '#2',
    level: '27'
  }, {
    category: '+ 57/-67 Kg / -126/148 lbs',
    size: '#3',
    level: '30'
  }, {
    category: '+ 67 Kg / 148 lbs',
    size: '#3',
    level: '32'
  }];
  const paraMaleData = [{
    category: '- 58 Kg / 128 lbs',
    size: '#3',
    level: '20'
  }, {
    category: '+ 58/-68 Kg / 128 /150 lbs',
    size: '#3',
    level: '22'
  }, {
    category: '+ 68/-80 Kg / 150 /176 lbs',
    size: '#4',
    level: '24'
  }, {
    category: '+ 80 Kg / 176 lbs',
    size: '#5',
    level: '26'
  }];
  const paraFemaleData = [{
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '18'
  }, {
    category: '+ 49 /-57 Kg / 108 /126 lbs',
    size: '#2',
    level: '19'
  }, {
    category: '+ 57 /-67 Kg / 126 /148 lbs',
    size: '#3',
    level: '20'
  }, {
    category: '+ 67 Kg / 148 lbs',
    size: '#3',
    level: '22'
  }];
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-564">
      <Header data-id="element-565" />

      <main className="flex-grow pt-32 pb-20" data-id="element-566">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-567">
          {/* Page Header */}
          <div className="text-center mb-10" data-id="element-568">
            <h1 className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3" data-id="element-569">
              Thresholds / Hit Levels
            </h1>
            <p className="text-lg text-gray-600 uppercase tracking-wide font-medium" data-id="element-570">
              DAEDO - EP SYSTEM, SIZE & LEVEL
            </p>
          </div>

          {/* Division Selector */}
          <div className="max-w-md mx-auto mb-12" data-id="element-571">
            <label htmlFor="division-select" className="block text-sm font-bold text-gray-700 mb-2 text-center uppercase tracking-wider" data-id="element-572">
              Select Division
            </label>
            <div className="relative" data-id="element-573">
              <select id="division-select" value={selectedDivision} onChange={e => setSelectedDivision(e.target.value)} className="block w-full appearance-none bg-white border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-semibold text-lg cursor-pointer transition-colors hover:border-blue-400" data-id="element-574">
                {divisions.map(division => <option key={division} value={division} data-id="element-575">
                    {division}
                  </option>)}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500" data-id="element-576">
                <ChevronDownIcon className="h-5 w-5" data-id="element-577" />
              </div>
            </div>
          </div>

          {/* Content Area */}
          {selectedDivision === 'Junior Level' ? <div className="space-y-12" data-id="element-578">
              {/* Junior Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-579">
                <div className="bg-blue-600 px-6 py-4" data-id="element-580">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-581">
                    Junior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-582">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-583">
                    <tbody data-id="element-584">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-585">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-586">
                          Category
                        </td>
                        {maleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-587">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-588">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-589">
                          Size EBP
                        </td>
                        {maleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-590">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-591">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-592">
                          LEVEL
                        </td>
                        {maleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-593">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Junior Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-594">
                <div className="bg-pink-600 px-6 py-4" data-id="element-595">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-596">
                    Junior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-597">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-598">
                    <tbody data-id="element-599">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-600">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-601">
                          Category
                        </td>
                        {femaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-602">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-603">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-604">
                          Size EBP
                        </td>
                        {femaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-605">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-606">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-607">
                          LEVEL
                        </td>
                        {femaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-608">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'Senior Level' ? <div className="space-y-12" data-id="element-609">
              {/* Senior Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-610">
                <div className="bg-blue-600 px-6 py-4" data-id="element-611">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-612">
                    Senior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-613">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-614">
                    <tbody data-id="element-615">
                      <tr className="border-b border-gray-200 bg-blue-50" data-id="element-616">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-617"></td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600" data-id="element-618">
                            {item.weight}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-619">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-620">
                          Category
                        </td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-621">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-622">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-623">
                          Size EBP
                        </td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-624">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-625">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-626">
                          LEVEL
                        </td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-627">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Senior Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-628">
                <div className="bg-pink-600 px-6 py-4" data-id="element-629">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-630">
                    Senior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-631">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-632">
                    <tbody data-id="element-633">
                      <tr className="border-b border-gray-200 bg-pink-50" data-id="element-634">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-635"></td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600" data-id="element-636">
                            {item.weight}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-637">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-638">
                          Category
                        </td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-639">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-640">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-641">
                          Size EBP
                        </td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-642">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-643">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-644">
                          LEVEL
                        </td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-645">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'Cadet Level' ? <div className="space-y-12" data-id="element-646">
              {/* Cadet Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-647">
                <div className="bg-blue-600 px-6 py-4" data-id="element-648">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-649">
                    Cadet MALE
                  </h2>
                </div>
                <div data-id="element-650">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-651">
                    <tbody data-id="element-652">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-653">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-654">
                          Category
                        </td>
                        {cadetMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-655">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-656">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-657">
                          Size
                        </td>
                        {cadetMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-658">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-659">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-660">
                          LEVEL
                        </td>
                        {cadetMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-661">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Cadet Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-662">
                <div className="bg-pink-600 px-6 py-4" data-id="element-663">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-664">
                    Cadet FEMALE
                  </h2>
                </div>
                <div data-id="element-665">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-666">
                    <tbody data-id="element-667">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-668">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-669">
                          Category
                        </td>
                        {cadetFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-670">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-671">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-672">
                          Size
                        </td>
                        {cadetFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-673">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-674">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-675">
                          LEVEL
                        </td>
                        {cadetFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-676">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'Kids Level' ? <div className="space-y-12" data-id="element-677">
              {/* Kids 6-7 years */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-678">
                <div className="bg-green-600 px-6 py-4" data-id="element-679">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-680">
                    Kids Level (6-7 years)
                  </h2>
                  <p className="text-green-100 text-sm mt-1" data-id="element-681">
                    SIZE & HIT LEVEL - DAEDO PSS (2014)
                  </p>
                </div>
                <div data-id="element-682">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-683">
                    <tbody data-id="element-684">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-685">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-686">
                          Category
                        </td>
                        {kids6to7Data.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-687">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-688">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-689">
                          Size
                        </td>
                        {kids6to7Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-690">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-691">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-692">
                          LEVEL
                        </td>
                        {kids6to7Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-693">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Kids 8-9 years */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-694">
                <div className="bg-teal-600 px-6 py-4" data-id="element-695">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-696">
                    Kids Level (8-9 years)
                  </h2>
                  <p className="text-teal-100 text-sm mt-1" data-id="element-697">
                    SIZE & HIT LEVEL - DAEDO PSS (2014)
                  </p>
                </div>
                <div data-id="element-698">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-699">
                    <tbody data-id="element-700">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-701">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-702">
                          Category
                        </td>
                        {kids8to9Data.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-703">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-704">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-705">
                          Size
                        </td>
                        {kids8to9Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-706">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-707">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-708">
                          LEVEL
                        </td>
                        {kids8to9Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-709">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Kids 10-11 years */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-710">
                <div className="bg-emerald-600 px-6 py-4" data-id="element-711">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-712">
                    Kids Level (10-11 years)
                  </h2>
                </div>
                <div data-id="element-713">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-714">
                    <tbody data-id="element-715">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-716">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-717">
                          Category
                        </td>
                        {kids10to11Data.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-718">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-719">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-720">
                          Size
                        </td>
                        {kids10to11Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-721">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-722">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-723">
                          LEVEL
                        </td>
                        {kids10to11Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-724">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'W.T.F. Olympic Category' ? <div className="space-y-12" data-id="element-725">
              {/* Olympic Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-726">
                <div className="bg-blue-600 px-6 py-4" data-id="element-727">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-728">
                    Senior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-729">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-730">
                    <tbody data-id="element-731">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-732">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-733">
                          Category
                        </td>
                        {olympicMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-734">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-735">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-736">
                          Size EBP
                        </td>
                        {olympicMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-737">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-738">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-739">
                          LEVEL
                        </td>
                        {olympicMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-740">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Olympic Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-741">
                <div className="bg-pink-600 px-6 py-4" data-id="element-742">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-743">
                    Senior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-744">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-745">
                    <tbody data-id="element-746">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-747">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-748">
                          Category
                        </td>
                        {olympicFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-749">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-750">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-751">
                          Size EBP
                        </td>
                        {olympicFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-752">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-753">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-754">
                          LEVEL
                        </td>
                        {olympicFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-755">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'W.T.F. Para Taekwondo' ? <div className="space-y-12" data-id="element-756">
              {/* Para Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-757">
                <div className="bg-blue-600 px-6 py-4" data-id="element-758">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-759">
                    Senior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-760">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-761">
                    <tbody data-id="element-762">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-763">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-764">
                          Category
                        </td>
                        {paraMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-765">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-766">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-767">
                          Size EBP
                        </td>
                        {paraMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-768">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-769">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-770">
                          LEVEL
                        </td>
                        {paraMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-771">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Para Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-772">
                <div className="bg-pink-600 px-6 py-4" data-id="element-773">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-774">
                    Senior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-775">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-776">
                    <tbody data-id="element-777">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-778">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-779">
                          Category
                        </td>
                        {paraFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-780">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-781">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-782">
                          Size EBP
                        </td>
                        {paraFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-783">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-784">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-785">
                          LEVEL
                        </td>
                        {paraFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-786">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> /* Coming Soon State for other divisions */ : <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center max-w-2xl mx-auto" data-id="element-787">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-788">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-789">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-790" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-791">
                {selectedDivision} Data Coming Soon
              </h2>
              <p className="text-gray-600 text-lg" data-id="element-792">
                We are currently updating our database with the latest
                thresholds and hit levels for this division. Please check back
                later.
              </p>
            </div>}
        </div>
      </main>

      <Footer data-id="element-793" />
    </div>;
}